import { ApiCrud } from 'adready-api/api/api-crud';
import http from 'adready-api/api/http';

const liStatsApi = new ApiCrud(http.AXIOS, {
  lineItemStatusCount: '/ios/plan/lineItemStatusCount',
  lineItemStatusCountForPlans: '/ios/plan/lineItemStatusCountForPlans',
});
export default liStatsApi;
